import React, { useState } from 'react';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';

const BackfillMenuImages = () => {
    const [isUpdating, setIsUpdating] = useState(false);
    const [log, setLog] = useState([]);

    const imageMap = {
        dosas: 'https://images.unsplash.com/photo-1604908554007-089f8a6b8ede?w=400&h=400&fit=crop',
        dosa: 'https://images.unsplash.com/photo-1604908177235-6c8e9ff9e4b0?w=400&h=400&fit=crop',
        idli: 'https://images.unsplash.com/photo-1627308595229-7830a5c91f9f?w=400&h=400&fit=crop',
        sambar: 'https://images.unsplash.com/photo-1643379444862-7e0c9961c3c7?w=400&h=400&fit=crop',
        chutney: 'https://images.unsplash.com/photo-1627308594761-3fef9e0d4a25?w=400&h=400&fit=crop',
        mintchutney: 'https://images.unsplash.com/photo-1626082922552-8d9d5f2de26c?w=400&h=400&fit=crop',
        tomatoc: 'https://images.unsplash.com/photo-1617095976600-0fa2e72acab9?w=400&h=400&fit=crop',
        rice: 'https://images.unsplash.com/photo-1604908554007-089f8a6b8ede?w=400&h=400&fit=crop',
        dal: 'https://images.unsplash.com/photo-1625944528474-8fbc67f1820a?w=400&h=400&fit=crop',
        curry: 'https://images.unsplash.com/photo-1625944528543-ccf5c9e97ed8?w=400&h=400&fit=crop',
        papad: 'https://images.unsplash.com/photo-1625944622051-86a11b15412f?w=400&h=400&fit=crop',
        upma: 'https://images.unsplash.com/photo-1668236542291-4e3c4ad30599?w=400&h=400&fit=crop',
        tea: 'https://images.unsplash.com/photo-1517705008128-361805f42e86?w=400&h=400&fit=crop',
        raita: 'https://images.unsplash.com/photo-1600959907703-153f7fec5c90?w=400&h=400&fit=crop',
        aloo: 'https://images.unsplash.com/photo-1625944528423-8f3f7a7acb1b?w=400&h=400&fit=crop',
        roti: 'https://images.unsplash.com/photo-1617195737490-3cccd508c24f?w=400&h=400&fit=crop',
        paneer: 'https://images.unsplash.com/photo-1631452180519-7c9f0f1a5a2a?w=400&h=400&fit=crop',
        puri: 'https://images.unsplash.com/photo-1634836297151-0b0a706ba5d2?w=400&h=400&fit=crop',
        jeerarice: 'https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400&h=400&fit=crop',
        yellowdal: 'https://images.unsplash.com/photo-1625944528474-8fbc67f1820a?w=400&h=400&fit=crop',
        oats: 'https://images.unsplash.com/photo-1526312426976-593c2be22320?w=400&h=400&fit=crop',
        milk: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=400&h=400&fit=crop',
        quinoa: 'https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=400&h=400&fit=crop',
        tofu: 'https://images.unsplash.com/photo-1604908554007-089f8a6b8ede?w=400&h=400&fit=crop',
        vegetables: 'https://images.unsplash.com/photo-1543363136-2b8ccfea3a1b?w=400&h=400&fit=crop',
        soup: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=400&h=400&fit=crop',
        salad: 'https://images.unsplash.com/photo-1556800467-9cc15f2a5b2e?w=400&h=400&fit=crop',
        bread: 'https://images.unsplash.com/photo-1546554137-f86b9593a222?w=400&h=400&fit=crop',
        egg: 'https://images.unsplash.com/photo-1513442542250-854d436a73f2?w=400&h=400&fit=crop',
        pickle: 'https://images.unsplash.com/photo-1615485737651-d6f5bf86de1c?w=400&h=400&fit=crop',
    };

    const getImageFor = (key) => imageMap[key] || 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&h=400&fit=crop';

    const backfill = async () => {
        setIsUpdating(true);
        const logs = [];
        try {
            const packagesSnapshot = await getDocs(collection(db, 'packages'));
            for (const pkgDoc of packagesSnapshot.docs) {
                const data = pkgDoc.data();
                if (!Array.isArray(data.weeklyMenu)) continue;

                let changed = false;
                const newWeeklyMenu = data.weeklyMenu.map(day => ({
                    ...day,
                    meals: (day.meals || []).map(meal => ({
                        ...meal,
                        items: (meal.items || []).map(item => {
                            if (!item.imageUrl) {
                                changed = true;
                                return { ...item, imageUrl: getImageFor((item.foodItemId || '').toLowerCase()) };
                            }
                            return item;
                        })
                    }))
                }));

                if (changed) {
                    await updateDoc(doc(db, 'packages', pkgDoc.id), { weeklyMenu: newWeeklyMenu });
                    logs.push(`Updated: ${data.name || pkgDoc.id}`);
                } else {
                    logs.push(`No change needed: ${data.name || pkgDoc.id}`);
                }
            }
            setLog(logs);
            alert('Backfill complete!');
        } catch (e) {
            console.error('Backfill error:', e);
            alert('Error during backfill. Check console for details.');
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: 800, margin: '0 auto' }}>
            <h2>Backfill Weekly Menu Images</h2>
            <p>This one-time utility will add imageUrl to each weekly menu item in all packages, if missing.</p>
            <button
                onClick={backfill}
                disabled={isUpdating}
                style={{
                    padding: '12px 24px',
                    fontSize: '16px',
                    backgroundColor: '#6366f1',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: isUpdating ? 'not-allowed' : 'pointer'
                }}
            >
                {isUpdating ? 'Updating...' : 'Backfill Images'}
            </button>
            {log.length > 0 && (
                <div style={{ marginTop: 20, textAlign: 'left' }}>
                    <h4>Log</h4>
                    <ul>
                        {log.map((l, i) => (<li key={i}>{l}</li>))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default BackfillMenuImages;


